import { motion } from "framer-motion";
import { Phone, MessageCircle } from "lucide-react";

const CONTACTS = [
  { name: "Alagh Family", phone: "+91 98715 43377", slug: "alagh-family" },
  { name: "Alagh · Oberoi", phone: "+91 98996 88717", slug: "alagh-oberoi" },
  { name: "Chopra · Monga", phone: "+91 96541 09970", slug: "chopra-monga" },
  { name: "Wason · Kapoor", phone: "+91 85880 92209", slug: "wason-kapoor" },
];

export const Rsvp = () => (
  <section id="rsvp" data-testid="rsvp-section" className="relative py-20 sm:py-24 px-6">
    <div className="max-w-4xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="text-center"
      >
        <p className="font-mono-accent text-xs uppercase tracking-[0.3em] text-amber-400">
          RSVP
        </p>
      </motion.div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-12">
        {CONTACTS.map((c, i) => (
          <motion.div
            key={c.slug}
            data-testid={`contact-card-${c.slug}`}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: i * 0.1 }}
            className="card-glass rounded-2xl p-6 text-center"
          >
            <p className="font-mono-accent text-base text-amber-300">{c.phone}</p>
            <div className="flex justify-center gap-2 mt-5">
              <a
                data-testid={`contact-call-btn-${c.slug}`}
                href={`tel:${c.phone.replace(/\s/g, "")}`}
                className="btn-gold rounded-full p-2.5"
                aria-label={`Call ${c.name}`}
              >
                <Phone className="w-4 h-4" />
              </a>
              <a
                data-testid={`contact-whatsapp-btn-${c.slug}`}
                href={`https://wa.me/${c.phone.replace(/[\s+]/g, "")}`}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-outline-gold rounded-full p-2.5"
                aria-label={`WhatsApp ${c.name}`}
              >
                <MessageCircle className="w-4 h-4" />
              </a>
            </div>
          </motion.div>
        ))}
      </div>

      <p className="text-center text-sm text-zinc-400 mt-10">
        With best compliments from — All Relatives &amp; Friends
      </p>
    </div>
  </section>
);
